import { ApryseSDK } from '../../pdf/ApryseSDK';
import { GlobalVariables } from '../../pdf/GlobalVariables';
import Command from './_Command';

export default class ZoomController extends Command {
    constructor(layout: 'singlePage' | 'doublePage', icon: string) {
        const commandKey = `layoutController-${layout}`;

        GlobalVariables.registeredCommands[commandKey] = () => {
            if (layout === 'singlePage') {
                return ApryseSDK.instance.UI.setLayoutMode(ApryseSDK.instance.UI.LayoutMode.Single);
            }

            if (layout === 'doublePage') {
                return ApryseSDK.instance.UI.setLayoutMode(ApryseSDK.instance.UI.LayoutMode.FacingContinuous);
            }
        };

        super({
            Enabled: true,
            Key: commandKey,
            Path: icon,
            Callback: GlobalVariables.registeredCommands[commandKey],
        });
    }
}
